import { render, staticRenderFns } from "./MailError.vue?vue&type=template&id=1f79f8d3"
import script from "./MailError.vue?vue&type=script&lang=js"
export * from "./MailError.vue?vue&type=script&lang=js"
import style0 from "./MailError.vue?vue&type=style&index=0&id=1f79f8d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports